module.exports = __webpack_public_path__ + "img/voice_key.09dfe4ef.png";